var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wangEditor"}},[_c('div',{staticClass:"toolbar",staticStyle:{"z-index":"20"},attrs:{"id":"toolbar-container"}}),_c('div',{staticClass:"text_container",staticStyle:{"z-index":"0"},attrs:{"id":"text-container"}})])
}]

export { render, staticRenderFns }